
/* eslint-disable @nx/enforce-module-boundaries */
import { Heading, Link, Tab, TabList, Tabs, Text, Box, IconButton ,HStack} from '@mybridge/ui';
import { forwardRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BackArrow, BackArrowRTL } from '@mybridge/icons';
import { isMobile } from 'react-device-detect';
import MyNetworkSearchInput from 'v4/components/network/network-search-input'; // Assuming you have an ArrowBackIcon component
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

const useMyCircleTabs = ({ deps }) => {
  const { t } = useTranslator();
  const direction = useDirection();
  const tabs = useMemo(() => {
    return [
      {
        title: <Box>1<sup>st</sup> {t('profileNetwork.degree') || "Degree"}</Box>,
        name: 'first',
        link: '/profile/network/my-circle',
      },
      {
        title: <Box>2<sup>nd</sup> {t('profileNetwork.degree') || "Degree"}</Box>,
        name: 'second',
        link: '/profile/network/my-circle/second',
      },
      {
        title: <Box>3<sup>rd</sup> {t('profileNetwork.degree') || "Degree"}</Box>,
        name: 'third',
        link: '/profile/network/my-circle/third',
      },
    ];
  }, [...(deps ?? [])]);
  return {
    tabs,
  };
};

export const MyNetworkMyCircleTabs = forwardRef(({ active, ...props }, ref) => {
  const { tabs } = useMyCircleTabs({});
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { t } = useTranslator();
  const direction = useDirection();

  return (
    <>
      <HStack alignItems="center" justifyContent="center" mb={3}>
        {isMobile && (
          <IconButton
            icon={direction === 'rtl' ? <BackArrowRTL/> : <BackArrow />}
            aria-label="Back"
            variant="ghost"
            onClick={() => window.history.back()} // or any other back navigation logic
          />
        )}
        <Heading fontSize="20px" color="brandPrimary.500" fontWeight="400" textAlign={["center","start"]} flex="1">
          {isMobile ? t('profile.connections') || 'Connections' : (userProfileInfo?.first_name ? `${userProfileInfo?.first_name}'s ${t('profile.connections') || 'connections'}` : t('profile.connections') || 'Connections')}
        </Heading>
        {isMobile && ( <MyNetworkSearchInput searchType="myFirstDegree" />)}
      </HStack>
      <Tabs index={active} mb={6}>
        <TabList border="none"  justifyContent={["space-evenly" ,"flex-start"]}>
          {tabs?.map?.((t, tind) => (
            isMobile? <Tab
              border={['1px solid #4F4F4F', "none"]}
              borderRadius={['30px', 'none']}
              bg={active === tind ? '#3D5A80' : 'transparent'}
              color={active === tind ? '#fff' : '#4F4F4F'}
              {...(t.link ? { as: Link, href: t.link } : {})}
              key={t.name + '-' + tind}
            >
              {t.title}
            </Tab> : <Tab
              {...(t.link ? { as: Link, href: t.link } : {})}
              key={t.name + '-' + tind}
              
            >
              {t.title}
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </>
  );
});